import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import FilterModal from "../Filter Modal/FilterModal";
import axios from "axios";

export default function DataTable_Component({
  apidata,
  columns,
  searchBy,

  totalRows,
  currentPage,
  setCurrentPage,
  rowsPerPage,
  setRowsPerPage,

  dataFilter,
  setDataFilter,

  statusFilter,
  setStatusFilter,

  clientFilter,
  setClientFilter,

  staffTypeFilter,
  setStaffTypeFilter,

  monthFilter,
  setMonthFilter,

  rentalFilter,
  setRentalFilter,

  userSourceFilter,
  setUserSourceFilter,

  thirdPartyProviderFilter,
  setThirdPartyProviderFilter,
}) {
  const [showFilterModal, setShowFilterModal] = useState(false);

  const [clients, setClients] = useState([]);
  const [staffTypes, setStaffTypes] = useState([]);

  useEffect(() => {
    const fetchClients = async () => {
      try {
        const token = localStorage.getItem("token");
        const userRole = localStorage.getItem("userRole");

        if (!token) {
          console.error("No token found");
          return;
        }

        let apiUrl;

        if (userRole === "superadmin") {
          apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/clients`;
        } else if (userRole === "admin") {
          apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/hub/admin/clients`;
        } else if (userRole === "clientmanager") {
          apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/hub/client/clients`;
        } else {
          console.error("Unauthorized role:", userRole);
          return;
        }

        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setClients(response.data.clients || []);
      } catch (error) {
        console.log("Error fetching clients:", error);
      }
    };

    fetchClients();
  }, []);

  // ✅ FETCH STAFF TYPES
  useEffect(() => {
    const fetchStaffTypes = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }

        const res = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/general-staff-types`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        // ✅ IMPORTANT KEY
        setStaffTypes(res.data.generalStaffTypes || []);
      } catch (err) {
        console.error("StaffType fetch error", err);
      }
    };

    fetchStaffTypes();
  }, []);

  const applyFilters = () => {
    setCurrentPage(1);
    setShowFilterModal(false);
  };

  const removeFilters = () => {
    setStatusFilter("");
    setClientFilter("");
    setStaffTypeFilter("");
    setMonthFilter("");
    setRentalFilter("");
    setUserSourceFilter("");
    setThirdPartyProviderFilter("");
    setDataFilter("");
    setCurrentPage(1);
    setShowFilterModal(false);
  };

  const providerOptions = [
    ...new Map(
      (apidata || [])
        .map((user) => user.thirdPartyProvider?.trim())
        .filter(Boolean)
        .map((provider) => [provider.toLowerCase(), provider]),
    ).values(),
  ].map((provider) => ({
    value: provider,
    label: provider,
  }));

  return (
    <div className="table-responsive">
      <div className="row justify-content-between mb-2">
        <div className="col-md-3 mb-2">
          <input
            type="text"
            placeholder={`Search by name, phonenumber, account number, employeeId`}
            className="form-control"
            value={dataFilter}
            onChange={(e) => setDataFilter(e.target.value)}
          />
        </div>

        <div className="col-md-9 mb-2">
          <button
            className="btn btn-primary"
            onClick={() => setShowFilterModal(true)}
          >
            Filter
          </button>
        </div>
      </div>

      {/* ✅ SERVER SIDE PAGINATION */}
      <DataTable
        columns={columns}
        data={apidata}
        pagination
        paginationServer
        paginationTotalRows={totalRows}
        // ✅ KEEP EXACTLY SAME (your requirement)
        paginationPerPage={5}
        paginationRowsPerPageOptions={[5, 10, 15, 20]}
        paginationDefaultPage={currentPage}
        onChangePage={(page) => setCurrentPage(page)}
        onChangeRowsPerPage={(newPerPage) => {
          setRowsPerPage(newPerPage);
          // setCurrentPage(1);
        }}
        fixedHeader
        highlightOnHover
        responsive
      />

      <FilterModal
        show={showFilterModal}
        onHide={() => setShowFilterModal(false)}
        statusFilter={statusFilter}
        setStatusFilter={setStatusFilter}
        clientFilter={clientFilter}
        setClientFilter={setClientFilter}
        staffTypeFilter={staffTypeFilter}
        setStaffTypeFilter={setStaffTypeFilter}
        monthFilter={monthFilter}
        setMonthFilter={setMonthFilter}
        applyFilters={applyFilters}
        removeFilters={removeFilters}
        clients={clients}
        staffTypes={staffTypes}
        rentalFilter={rentalFilter}
        setRentalFilter={setRentalFilter}
        userSourceFilter={userSourceFilter}
        setUserSourceFilter={setUserSourceFilter}
        thirdPartyProviderFilter={thirdPartyProviderFilter}
        setThirdPartyProviderFilter={setThirdPartyProviderFilter}
        providerOptions={providerOptions}
      />
    </div>
  );
}
